if (!customElements.get('main-product')) {
  customElements.define(
    'main-product',
    class MainProduct extends HTMLElement {
      constructor() {
        super()
        this.id = `shopify-section-${this.dataset.id}`

        this.init()
      }
      init() {
        this.play()
      }
      play() {
        if (!$.isFunction($().slick)) {
          console.error('jQueryもしくはSlickが読み込まれていません。')
          return
        }
        this.$current = $(this)
        if (
          this.$current.find(
            '.product-slider .slider-main .slick-img .img_wrap',
          ).length <= 1
        ) {
          // スライドが1枚以下の場合は処理しない
          return
        }
        this.$current.find('.product-slider .slider-main').slick({
          autoplay: true,
          arrows: this.dataset.arrows === 'false' ? false : true,
          asNavFor: `#${this.id} .product-slider .slider-thumbnail`,
          responsive: [
            {
              breakpoint: 575,
              settings: {
                arrows: false,
              },
            },
          ],
        })
        this.$current.find('.slider-thumbnail').slick({
          slidesToShow: 4,
          asNavFor: `#${this.id} .product-slider .slider-main`,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 575,
              settings: {
                arrows: false,
              },
            },
          ],
        })
      }
      pause() {
        this.$current.find('.slider-main').slick('unslick')
        this.$current.find('.slider-thumbnail').slick('unslick')
      }
    },
  )
}

class chipCheckChange extends HTMLElement {
  constructor() {
    super()
    this.chipInput = this.querySelector('.chip-input')
    const valiationChip = document.getElementsByName(
      this.chipInput.getAttribute('name'),
    )
    this.chipInput.addEventListener('change', () => {
      if (this.chipInput.checked) {
        for (let i = 0; i < valiationChip.length; i++) {
          valiationChip[i].checked = false
          valiationChip[i].classList.remove('checked-input')
        }
        this.chipInput.checked = true
        this.chipInput.classList.add('checked-input')
      } else {
        this.chipInput.classList.remove('checked-input')
      }
    })
  }
}

customElements.define('valiation-chip', chipCheckChange)

class quantityInputNumber extends HTMLElement {
  constructor() {
    super()
    this.btnMinus = this.querySelector('.btn-minus')
    this.btnPlus = this.querySelector('.btn-plus')
    this.quantityInput = document.querySelector('.quantity__input')
    this.quantityInput.value = 1
    this.btnMinus.addEventListener('click', function () {
      this.quantityInput = document.querySelector('.quantity__input')
      this.quantityInput.value = Number(this.quantityInput.value) - 1
      if (
        this.quantityInput.value <
        Number(this.quantityInput.getAttribute('min'))
      ) {
        this.quantityInput.value = Number(
          this.quantityInput.getAttribute('min'),
        )
      }
    })
    this.btnPlus.addEventListener('click', function () {
      this.quantityInput = document.querySelector('.quantity__input')
      this.quantityInput.value = Number(this.quantityInput.value) + 1
      if (
        this.quantityInput.value >
        Number(this.quantityInput.getAttribute('max'))
      ) {
        this.quantityInput.value = Number(
          this.quantityInput.getAttribute('max'),
        )
      }
    })
  }
}

customElements.define('quantity-input-number', quantityInputNumber)

class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.removeErrorMessage()
    this.updateVariantStatuses()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      // this.updateProductInfo()
      this.updateVariantInput()
      this.updateProductSlide()
      this.renderProductInfo()
      this.updateShareUrl()
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value,
    )
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    )
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      ),
    )

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    )
    if (!modalContent) return
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    )
    modalContent.prepend(newMediaModal)
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    )
  }

  // updateProductInfo() {
  //   let url = new URL(window.location.href)
  //   let params = url.searchParams
  //   if (variantStock[params.get('variant')] <= 0) {
  //     document
  //       .getElementById('stock_status')
  //       .classList.remove(...document.getElementById('stock_status').classList)
  //     document.getElementById('stock_status').classList.add('out-of-stock')
  //     document.getElementById('stock_status').innerText = '売り切れ'
  //   } else if (variantStock[params.get('variant')] < 10) {
  //     document
  //       .getElementById('stock_status')
  //       .classList.remove(...document.getElementById('stock_status').classList)
  //     document.getElementById('stock_status').classList.add('few-stock')
  //     document.getElementById('stock_status').innerText =
  //       '残り' + variantStock[params.get('variant')] + '個'
  //   } else {
  //     document
  //       .getElementById('stock_status')
  //       .classList.remove(...document.getElementById('stock_status').classList)
  //     document.getElementById('stock_status').classList.add('in-stock')
  //     document.getElementById('stock_status').innerText = '在庫あり'
  //   }
  //   document.getElementById('sku').innerText = variantSku[params.get('variant')]
  // }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton || !shareButton.updateUrl) return
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updateProductSlide() {
    const main_product = document.querySelector('main-product')
    main_product.pause()
    let url = new URL(window.location.href)
    let params = url.searchParams
    const slider_main = document.querySelector('.slider-main')
    const slider_thumbnail = document.querySelector('.slider-thumbnail')
    const toNode = (str) => document.createRange().createContextualFragment(str)
    const variant_main_img = document.getElementsByClassName('variant-main-img')
    console.log(variant_main_img.length)
    console.log(variant_main_img)
    if (variant_main_img.length > 0) {
      for (let i = 0; i < variant_main_img.length; i++) {
        variant_main_img[i].remove()
      }
    }
    const variant_thumbnail_img = document.getElementsByClassName(
      'variant-thumbnail-img',
    )
    console.log(variant_thumbnail_img.length)
    console.log(variant_thumbnail_img)
    if (variant_thumbnail_img.length > 0) {
      for (let i = 0; i < variant_thumbnail_img.length; i++) {
        variant_thumbnail_img[i].remove()
      }
    }
    if (params.get('variant') in variantImages) {
      slider_main.insertBefore(
        toNode(
          `<div class="slick-img variant-main-img"><div class="img_wrap">${
            variantImages[params.get('variant')]
          }</div></div>`,
        ),
        slider_main.children[0],
      )
      slider_thumbnail.insertBefore(
        toNode(
          `<div class="thumbnail-img variant-thumbnail-img"><div class="img_wrap">${
            variantImages[params.get('variant')]
          }</div></div>`,
        ),
        slider_thumbnail.children[0],
      )
    }
    main_product.play()
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1,
    )
    const inputWrappers = [...this.querySelectorAll('.product-form__input')]
    inputWrappers.forEach((option, index) => {
      if (index === 0) return
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ]
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`])
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    })
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value')
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value'),
        )
      }
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage() {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        )
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        )
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        )
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        )
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        )
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        )

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        )

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`,
        )
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        )

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`,
        )

        if (source && destination) destination.innerHTML = source.innerHTML
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML
          skuDestination.classList.toggle(
            'visibility-hidden',
            skuSource.classList.contains('visibility-hidden'),
          )
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML
          pricePerItemDestination.classList.toggle(
            'visibility-hidden',
            pricePerItemSource.classList.contains('visibility-hidden'),
          )
        }

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove('visibility-hidden')

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            'visibility-hidden',
            inventorySource.innerText === '',
          )

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`,
        )
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
        )

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        })
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    )
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')
    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButtonText.innerHTML = text
    } else {
      addButton.removeAttribute('disabled')
      addButtonText.innerHTML = window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    )
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const price = document.getElementById(`price-${this.dataset.section}`)
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    )
    const sku = document.getElementById(`Sku-${this.dataset.section}`)
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`,
    )

    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add('visibility-hidden')
    if (inventory) inventory.classList.add('visibility-hidden')
    if (sku) sku.classList.add('visibility-hidden')
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled')
      } else {
        input.classList.add('disabled')
      }
    })
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked,
      ).value
    })
  }
}

customElements.define('variant-radios', VariantRadios)
